import { Component, OnInit } from '@angular/core';
import { ApiPartnerService } from '../../api/api-partner.service';
import { ActivatedRoute, Router, ParamMap } from '@angular/router';
import { FormGroup, FormControl, FormBuilder, NgForm } from '@angular/forms';
import {URLSearchParams} from '@angular/http';
import { AuthenticationService } from '../../_services/authentication.service';



@Component({
  selector: 'app-customer',
  templateUrl: './customer.component.html',
  styleUrls: ['./customer.component.css']
})
export class CustomerComponent implements OnInit {

  permision : string[] = [];
  currentuser : any = {};


  ListCustomer: any = {};	
  paging: any = {};	
  msearch : string;
  typesearch : string;
  statustype : string;
  pairingto : string;

  //paging_link : any = [];
  page_self = [];
  page_next = [];
  page_prev = [];
  last_index : number;
  first_index : number;
  total_count : number;
  querySearch = false;
  searching = false;
  dataempty = true;
  currentParams = {};
  queryParams = '';
  searchQueryParams = '';
  href='';
  alert_act='';
  alert_actmsg='';

  _STBdata: any = {
    'sn': ''
  };	
  
  table_load = false

  meta = [];
  self = [];
  searchdata = [];
  
  formSearch = this.fb.group({
    search: [''],
  })
  
  constructor(public partnerService: ApiPartnerService,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private router: Router,
    private Auth: AuthenticationService,
    ) { }

  ngOnInit() {
    this.currentuser = this.Auth.currentUserValue;
    this.permision = this.currentuser.permision;
    this.loadStart();
  }

  refreshPage() {
    this.ngOnInit();
  }

  loadStart() {

    this.route.queryParams
      //.filter(params => params.order)
      .subscribe(params => {
        console.log(params); // {order: "popular"}

        //this.order = params.order;
        //console.log(this.order); // popular

        if (params.search != '' && params.search != undefined ){
          console.log('search');
          console.log(params.search);
         this.msearch = params.search; 
         this.querySearch = true;
         this.typesearch = params.typesearch;
         this.statustype = params.statustype; 
        

         this.currentParams = params;
         this.queryParams = '?'+this.queryStr(params);
         this.loadcustomer(this.queryParams);
        
        }else{
          this.querySearch = false;
          this.currentParams = params;
          this.statustype = params.statustype; 

          this.queryParams = '?'+this.queryStr(params);

          console.log(this.queryParams);
          console.log(this.queryStr(params));
          
          /* pagination */
          //this.loadworkorder(this.currentParams);
          this.loadcustomer(this.queryParams);
        }
      });

    //this.table_load = true
    
  }

  queryStr(options: any){
    let params = new URLSearchParams();
    for(let key in options){
        params.set(key, options[key]) 
    }
    return params.toString();
  }

  search()
  {
    this.querySearch = true;
    //this.searchQueryParams = this.queryParams+'&search='+this.msearch;
    if ( this.typesearch == undefined ){
      this.searchQueryParams = '?page='+this.page_self['page']+'&search='+this.msearch;
    }else{
      this.searchQueryParams = '?page='+this.page_self['page']+'&search='+this.msearch+'&typesearch='+this.typesearch;
    }
    
    if ( this.statustype != undefined ){
      this.searchQueryParams += '&statustype='+this.statustype;
    }
    if ( this.pairingto != undefined ){
      this.searchQueryParams += '&pairingto='+this.pairingto;
    }

    this.loadcustomer(this.searchQueryParams);
  }

  loadcustomer(queryParams: any)
  {
    this.table_load = true
    return this.partnerService.GetCustomers(queryParams).subscribe((output: any) => {
        this.ListCustomer = output.data;
        console.log(output);
        this.table_load = false
        //this.customerid = this.ViewSTB.data.customer.id;

        this.paging = output.pagex;
        this.page_self = output.pagex.self;
        this.page_next = output.pagex.next;
        this.page_prev = output.pagex.prev;
        this.meta = output.meta;
        this.total_count = this.meta['totalCount'];
        let self = this.page_self['page'];
        if ( self * this.meta['perPage'] < this.meta['totalCount']){
          this.last_index = (self * this.meta['perPage']);
        }else{
          this.last_index = this.meta['totalCount'];
        }
        
        this.first_index = ((self-1)*this.meta['perPage'])+1;
      })
  }

  _STB(item: any){
    // console.log(item);
    if (!item.stb ) {
      return '-'
    }else{
      return item.stb
    }
    // this._STBdata = item; 
    // return this._STBdata;
  }

  _services(item: any)
  {
    let service = '';
    if ( item.services == null || item.services == 0 ){
      return service;
    }else{
      item.services.forEach(function (value: any) {
        service += value.service['productname'] + '\n';
      });

      return service.replace(/(\\r\\n)|([\r\n])/gmi, ', ');
    }
  }
  
  isActive(item: any)
  {
    return (item.customersts == 10);
  }

  searchCust() {
    // this.formPartner.get('search').setValue(this.data_partner)

    const data = {
      "search" : this.formSearch.value.search,
      "type" : "name",
    }

    this.partnerService.getApipagelistpartner(data)
      .subscribe((output: any) => {

        this.searchdata = output.data;
        console.log(output);
      }
    );
  }

  MyPermission(p)
  {
  //console.log(this.permision);
    if ( this.permision == undefined ){
      return false;
    }
    if (this.permision.indexOf(p) > -1){
      return true;
    }else{
        return false;
    }
  }
}
